<!-- 会员卡核销记录 -->
<template>
  <div class="diseaseList">
    <!-- 筛选区 + 统计，与表格拼接成整块白卡 -->
    <div class="filter-bar">
      <el-form :inline="true" class="filter-form">
        <el-form-item label="门店ID" size="small">
          <el-input
            v-model="listQuery.store_id"
            placeholder="请输入"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="会员手机号" size="small">
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="核销人手机号" size="small">
          <el-input
            v-model="listQuery.cancel_phone"
            placeholder="请输入"
            clearable
            @keyup.enter.native="handleSearch"
            @clear="handleSearch"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="filter-meta">
        共 <span class="meta-num">{{ listQuery.total || 0 }}</span> 条核销记录
      </div>
    </div>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        :height="tableHeight"
        header-bg-color="#F1F6FC"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="store" slot-scope="{ row }">
          <div class="two-line-cell">
            <div :class="['cell-main', { 'cell-empty': !row.store_name }]">
              {{ row.store_name || "—" }}
            </div>
            <div :class="['cell-sub', { 'cell-empty': !row.store_id }]">
              {{ row.store_id ? "门店ID：" + row.store_id : "—" }}
            </div>
          </div>
        </template>
        <template slot="type" slot-scope="{ row }">
          <span class="type-chip" :class="'type-' + typeKey(row.type)">{{
            row.type || "—"
          }}</span>
        </template>
        <template slot="vipNumber" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.vip_number }]">{{
            row.vip_number || "—"
          }}</span>
        </template>
        <template slot="userPhone" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.user_phone }]">{{
            row.user_phone || "—"
          }}</span>
        </template>
        <template slot="cancel" slot-scope="{ row }">
          <div class="two-line-cell">
            <div :class="['cell-main', { 'cell-empty': !row.cancel_phone }]">
              {{ row.cancel_phone || "—" }}
            </div>
            <div :class="['cell-sub', { 'cell-empty': !row.cancel_id }]">
              {{ row.cancel_id ? "核销人ID：" + row.cancel_id : "—" }}
            </div>
          </div>
        </template>
        <template slot="amount" slot-scope="{ row }">
          <span
            v-if="row.amount === null || row.amount === undefined || row.amount === ''"
            class="cell-empty"
            >—</span
          >
          <span
            v-else
            class="amount-text"
            :class="Number(row.amount) < 0 ? 'amount-out' : 'amount-in'"
            >{{ Number(row.amount) < 0 ? row.amount : "+" + row.amount }}</span
          >
        </template>
        <template slot="balance" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.balance }]">{{
            row.balance || "—"
          }}</span>
        </template>
        <template slot="message" slot-scope="{ row }">
          <el-tooltip
            :content="row.message"
            placement="top"
            :disabled="!row.message"
          >
            <span :class="['cell-text', { 'cell-empty': !row.message }]">{{
              row.message || "—"
            }}</span>
          </el-tooltip>
        </template>
        <template slot="createTime" slot-scope="{ row }">
          <span :class="['cell-text', { 'cell-empty': !row.create_time }]">{{
            row.create_time || "—"
          }}</span>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" disabled @click="handleDelete(row)"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import { selectVipcardRecoder } from "@/services/plus/vipcardRecode";
export default {
  components: {
    ElTable,
  },
  async created() {
    this.getListData();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      loading: false,
      /* 视口高度，用于计算表格自适应高度 */
      winHeight: window.innerHeight,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
      },
      /* 表格数据 */
      tableData: [],
    };
  },
  computed: {
    listHeader,
    /* 表格高度：尽量占满视口，白卡整体向下拉长 */
    tableHeight() {
      return `${Math.max(this.winHeight - 250, 320)}px`;
    },
  },
  watch: {},
  methods: {
    handleResize() {
      this.winHeight = window.innerHeight;
    },
    /* 会员卡类型对应的样式 key */
    typeKey(type) {
      if (type === "储值卡") return "save";
      if (type === "积分卡") return "point";
      if (type === "次卡") return "times";
      return "none";
    },
    async getListData() {
      this.loading = true;
      try {
        const { data, code, count } = await selectVipcardRecoder(this.listQuery);
        if (code === 200) {
          this.tableData = data || [];
          this.listQuery.total = count || 0;
        }
      } finally {
        /* 稍作延迟，避免加载态一闪而过 */
        setTimeout(() => {
          this.loading = false;
        }, 300);
      }
    },
    /* 搜索：回车或清空触发 */
    async handleSearch() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 删除 */
    handleDelete(row) {},
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}

/* 筛选区：白色圆角卡片上半部，与表格拼接成一整块白卡 */
.filter-bar {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 16px 16px 12px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  .filter-form {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
  }
  /deep/ .el-form-item {
    margin-right: 16px;
    margin-bottom: 8px;

    .el-input__inner {
      width: 180px;
    }
  }

  /* 右侧统计，平衡一行视觉重心 */
  .filter-meta {
    flex-shrink: 0;
    padding-top: 6px;
    font-size: 13px;
    color: #8a94a6;

    .meta-num {
      color: #3d8dfc;
      font-weight: 600;
    }
  }
}

/* 表格区：白卡下半部，与筛选区严丝合缝 */
.tableList {
  border-radius: 0 0 8px 8px;
  background: #fff;
  padding: 12px 16px 16px;

  /* 单元格不换行，超出显示省略号 */
  /deep/ .el-table .cell {
    white-space: nowrap;
  }

  /* 单元格文本：单行省略 */
  .cell-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
  /* 无数据占位，避免单元格整片空白 */
  .cell-empty {
    color: #c0c4cc;
  }
}

/* 两行单元格：主信息 + 次要信息 */
.two-line-cell {
  padding: 6px 0;

  .cell-main {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #1d2129;
    line-height: 20px;
  }
  .cell-sub {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #86909c;
    line-height: 18px;
    margin-top: 2px;
  }
}

/* 会员卡类型：浅色底 + 同色文字 */
.type-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 4px;
  font-size: 12px;
  background: #f2f3f5;
  color: #86909c;

  &.type-save {
    background: #e8f8ee;
    color: #00b42a;
  }
  &.type-point {
    background: #e8f3ff;
    color: #3d8dfc;
  }
  &.type-times {
    background: #fde8e8;
    color: #f53f3f;
  }
}

/* 金额：支出红、入账绿 */
.amount-text {
  font-size: 14px;
  font-weight: 500;

  &.amount-out {
    color: #f53f3f;
  }
  &.amount-in {
    color: #00b42a;
  }
}

.operation {
  .el-button {
    padding: 0;
    color: #f56c6c;

    &:hover {
      color: #f78989;
    }
    /* 禁用态仍保留红色，提示「删除」语义 */
    &.is-disabled {
      color: #f56c6c;
      cursor: not-allowed;
    }
  }
}
</style>
